import { ReceiptType } from '@hooks-api/types/dataModel/eCommercePayments'
import { resolveInvoiceDetailFields as resolveDetailFields, resolveInvoiceUpdateDetailFields as resolveUpdateDetailFields, type InvoiceDetailFields } from '@utils/invoice-detail-fields'
import { type InvoiceBaseStore } from '../types'
import { CarrierValidationStatus, type CarrierValidationStatusType } from './carrier-validation-status'

export const setReceiptType = (state: InvoiceBaseStore, receiptType: ReceiptType): InvoiceBaseStore => {
  return {
    ...state,
    receiptType,
  }
}

export const setPhoneCarrierNumber = (state: InvoiceBaseStore, phoneCarrierNumber: string): InvoiceBaseStore => {
  return {
    ...state,
    phoneCarrierNumber,
  }
}

export const setCarrierValidationStatus = (state: InvoiceBaseStore, carrierValidationStatus: CarrierValidationStatusType): InvoiceBaseStore => {
  return {
    ...state,
    carrierValidationStatus,
  }
}

export const setRememberInvoiceCarrier = (state: InvoiceBaseStore, rememberInvoiceCarrier: boolean): InvoiceBaseStore => {
  return {
    ...state,
    rememberInvoiceCarrier,
  }
}

/**
 * 建單時是否夾帶 remember_invoice_carrier=true。
 * 僅手機條碼 + 勾選 + 驗證可寫入（有效 / 系統錯誤放行）才回 true；其餘（查無 / 未勾 / 訪客未勾選 default false / 非手機條碼）回 undefined → payload 不送旗標。
 */
export const resolveRememberInvoiceCarrier = (state: InvoiceBaseStore): true | undefined => {
  const isPhoneCarrier = state.receiptType === ReceiptType.PHONE_CARRIER
  const isStorable = state.carrierValidationStatus === CarrierValidationStatus.VALID
    || state.carrierValidationStatus === CarrierValidationStatus.SYSTEM_ERROR
  return isPhoneCarrier && state.rememberInvoiceCarrier && isStorable ? true : undefined
}

const toInvoiceDetailFieldsSource = (state: InvoiceBaseStore) => ({
  receipt_type: state.receiptType,
  business_ubn_title: state.businessUbnTitle,
  business_ubn: state.businessUbn,
  phone_carrier_number: state.phoneCarrierNumber,
  charity_organization: state.charityOrganization,
})

/** cart store（camelCase）版的 @hooks-api/utils/invoice-detail-fields，語意與共用實作一致 */
export const resolveInvoiceDetailFields = (state: InvoiceBaseStore): InvoiceDetailFields => {
  return resolveDetailFields(toInvoiceDetailFieldsSource(state))
}

export const resolveInvoiceUpdateDetailFields = (state: InvoiceBaseStore): Required<InvoiceDetailFields> => {
  return resolveUpdateDetailFields(toInvoiceDetailFieldsSource(state))
}

export const setCharityOrganization = (state: InvoiceBaseStore, charityOrganization: string): InvoiceBaseStore => {
  return {
    ...state,
    charityOrganization,
  }
}

export const setBusinessUbnTitle = (state: InvoiceBaseStore, businessUbnTitle: string): InvoiceBaseStore => {
  return {
    ...state,
    businessUbnTitle,
  }
}

export const setBusinessUbn = (state: InvoiceBaseStore, businessUbn: string): InvoiceBaseStore => {
  return {
    ...state,
    businessUbn,
  }
}

export const setRefundStatement = (state: InvoiceBaseStore, refundStatement: boolean): InvoiceBaseStore => {
  return {
    ...state,
    refundStatement,
  }
}
